// @flow
import type { RoamingPackage } from 'digicel-kaizen-library';

export default (roamingPackage: RoamingPackage) => {
  if (!roamingPackage) return [];
  const types = ['DATA', 'SMS', 'VOICE'];
  const rawCharacteristic = {
    ouid: roamingPackage.ouid,
    price: roamingPackage.price,
    periodicity: roamingPackage.periodicity,
  };
  const characteristics = roamingPackage.characteristics;
  // $FlowFixMe
  return Object.keys(characteristics)
    .filter(key => !key.includes('RAW'))
    .map(key => {
      for (let type of types) {
        if (key.includes(type)) {
          return {
            ...rawCharacteristic,
            name: key,
            type,
            characteristic: characteristics[key],
          };
        }
      }
    });
};
